module.exports = __webpack_public_path__ + "static/img/contactTwo.ad93003.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/contactTwo.png
// module id = BXpU
// module chunks = 1